export default __webpack_public_path__ + "static/media/ptov1.d12b56fb.png";